import classNames from 'classnames'
import type { ReactElement } from 'react'
import { CardSlot } from 'app/components/pipelines/CardSlot'
import type { ContactJson } from 'app/types/entities'
import type { CardFieldId } from 'lib/cardRecipe'
import type { CardDensity } from 'lib/listCardConfig'

/** Highlight: isolated as a focal stat panel (inset, not full width). */
export function HeroSection({
  field,
  contact,
  density,
}: {
  field: CardFieldId
  contact: ContactJson
  density: CardDensity
}): ReactElement {
  const compact = density === `compact`
  return (
    <div className={classNames(`mx-3 mb-2 rounded-lg bg-blue-500/[0.06] px-3`, compact ? `py-2` : `py-2.5`)}>
      <CardSlot slot="hero" fieldId={field} contact={contact} density={density} />
    </div>
  )
}
